export default "__VITE_ASSET__BZyQMGER__"